
<template>
    <div v-if="data?.data && data.data?.length > 0">
        <h4 class="mb-4 text-center"><span class="font-active">FAQs</span></h4>
        <FaqDynamicFaqList   :faqList="data.data" /> 
    </div>
</template>


<script setup>
	const route = useRoute();

	const { data  } = await useLazyFetch(useCountryPath("/config/faq?path=" + route.path), {

		onResponse({ request, response, options }) {
			
			if( response._data.success && response._data?.data  ){

				let schema_arr = []
				response._data.data.filter((list) =>{
					let obj = {
						"@type": "Question",
						"name": list.question,
						"acceptedAnswer": {
							"@type": "Answer",
							"text": list.answer
						}
					}
					schema_arr.push(obj)
				})

				// Setting up the head configuration using useHead
				useHead(() => {
					if (schema_arr.length) {
						return {
							script: [
								{
									type: 'application/ld+json',
									innerHTML: {
										"@context": "https://schema.org",
										"@type": "FAQPage",
										"mainEntity": schema_arr,
									},
								},
							],
						};
					}
					return {};
				});
			}
		}
	})

</script>


<style scoped>
    h4{
        font-size: 30px;
    }
    @media (max-width: 767px){
        h4{
            font-size: 24px;
        }
    }
</style>


